export default {
    AsterWhatsapp: {
        getdata: []
    }
};